import React from "react";
import { Link } from "react-router-dom";
import { IoArrowBack } from "react-icons/io5";

// Replace with your own image if available
// import serverDownImg from "../../assets/other/server_down.png";

const ErrorServerDown = () => {
  return (
    <div className="error-page">
      <div className="error-content">
        <img
          src="#"
          className="error-img img-light"
          alt="server-down"
        />
        <div className="error-text">
          <h2>Server is Down!</h2>
          <p>
            We’re having trouble connecting to our servers.  
            Please try again later.
          </p>
          <Link className="error-btn-link" to={"/"}>
            <button type="button" className="error-btn">
              <IoArrowBack />
              Back to Home
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ErrorServerDown;
